module.exports = __webpack_public_path__ + "static/media/heart.9a22fd2a.png";